import { COVERAGE_COLUMNS } from "../constants";

/** Same rules as backend `buildCoverageFlags` / home coverage table. */
export function allianceCoverageFromDocument(alliance: unknown): {
  present: number;
  pct: number;
  total: number;
} {
  const a = alliance as Record<string, unknown>;
  const total = COVERAGE_COLUMNS.length;
  let present = 0;
  for (const col of COVERAGE_COLUMNS) {
    const v = a[col.key];
    if (Array.isArray(v)) {
      if (v.length > 0) present++;
    } else if (v && typeof v === "object") {
      if (Object.keys(v as object).length > 0) present++;
    }
  }
  const pct = total > 0 ? Math.round((present / total) * 100) : 0;
  return { present, pct, total };
}
